import React, { Component } from 'react';
import './Signup.css';
import logoblue from '../../image/logoblue.png'
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar/Navbar'
import { LinkAPI } from '../../API/API'
import HandleRes from '../Components/HandleRes/HandleRes';
import axios from 'axios'
import Footer from '../Components/Footer/Footer'

class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: "",
            email: "",
            password: "",
            confirmpassword: "",
            nameError: "",
            emailError: "",
            phoneError: "",
            passwordError: "",
            confirmpasswordError: "",
            
            networkError: false,
            errordatamessage: false,
            errordatamessagetext: '',
            hasError: false,
        }
    }
    handleChange = event => {
        const isCheckbox = event.target.type === "checkbox";
        this.setState({
            [event.target.name]: isCheckbox
                ? event.target.checked
                : event.target.value
        });
    };
    componentDidMount() {
        window.scrollTo(0, 0)
      }
    validate = () => {
        let nameError = "";
        let emailError = "";
        let passwordError = "";
        let confirmpasswordError="";
        if (this.state.name.length < 2||!isNaN(this.state.name)) {
            nameError = "write your name correct";
        }
        if (this.state.password.length < 8) {
            passwordError = "Use 8 characters or more for your password";
        }
        
        if (this.state.confirmpassword.length < 8 || this.state.password !== this.state.confirmpassword) {
            confirmpasswordError = "Those passwords didn't match. Try again.";
        }

        if (!this.state.email.includes("@")) {
            emailError = "invalid email";
        }

        if (nameError||emailError || passwordError||confirmpasswordError) {
            this.setState({ nameError, emailError, passwordError, confirmpasswordError});
            return false;
        }

        return true;
    };

    handleSubmit = event => {
        event.preventDefault();
        const {name,email,phone,password}= this.state
        const isValid = this.validate();
        if (isValid) {
            axios.post(`${LinkAPI}/api/businessowner/signup`,{  name:name, email:email, password:password}).then(res =>{
                localStorage.setItem("userTokentConfirmData",res.data.businessOwner.token)
                window.location.replace("/ConfirmData");
             
                }).catch(error=>{
                if (!error.response) {
                    this.setState({
                        networkError: true,
                    })
                } else if (error.response.status === 402) {

                    window.location.replace("/SignIn");
                } else if (error.response.data.message) {
                    this.setState({
                        nameError: "",
                        emailError: "",
                        passwordError: "",
                        confirmpasswordError: "",
                        errordatamessage: true,
                        errordatamessageText: error.response.data.message,
                        
                    })
                } else {
                    this.setState({
                        hasError: true,
                    })
                }
                })
        }
    };
    render() {
        document.title ="Kayn | Sign Up"; 
        document.getElementsByTagName("META")[1].content="Kayn Sign Up";
        document.documentElement.lang = 'en';

        return (
            <div className=" AppEN signup">
                <Navbar />
                <div className='container'>
                    <div className="Sign  row">
                        <div className="logoform col-6 d-flex align-content-end flex-wrap">
                            <div className="col-12 text-center mt-auto p-2 bd-highlight"><Link to="/"><img className="logo" src={logoblue} alt="Kayn" /></Link>       </div>
                            <p className="fontsize2 text-center mb-5 col-12">Your package...your way</p>
                        </div>
                        <div className="col-md-6 form float-md-right  ">
                            <div className="contantform text-center p-4 ">
                                <h3 className="fontsize1 my-4">Sign up </h3>
                                <p className="fontsize6 my-4">Sign in to continue access pages</p>
                                <form className="px-lg-5" onSubmit={this.handleSubmit}>
                                    <div className="form-group my-4">
                                        <input type="text" className={"form-control badge-pill p-3 " + (this.state.nameError ? 'is-invalid' : '')} placeholder="Full Name" name="name" value={this.state.name} onChange={this.handleChange} required />
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.nameError}
                                        </div>
                                    </div>
                                    <div className="form-group my-4">
                                        <input type="email" className={"form-control badge-pill p-3 " + (this.state.emailError ? 'is-invalid' : '')} placeholder="Email Adderss" name="email" value={this.state.email} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" ,}}>
                                            {this.state.emailError}
                                        </div>
                                    </div>
                                    <div className="form-group my-4">
                                        <input type="password" className={"form-control badge-pill p-3 " + (this.state.passwordError ? 'is-invalid' : '')} placeholder=" password" name="password" value={this.state.password} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.passwordError}
                                        </div>
                                    </div>
                                    <div className="form-group my-4">
                                        <input type="password" id="confirm_password" className={"form-control badge-pill p-3 " + (this.state.confirmpasswordError ? 'is-invalid' : '')} placeholder="confirm password" name="confirmpassword" value={this.state.confirmpassword} onChange={this.handleChange} required/>
                                        <div style={{ fontSize: 12, color: "red" }}>
                                            {this.state.confirmpasswordError}
                                        </div>
                                    </div>
                                    {(this.state.errordatamessage ?
                      <div className="px-2" style={{ fontSize: 12, color: "red" }}>
                        {this.state.errordatamessageText}
                      </div> : '')}
                                    <button type="submit"className="btn badge-pill border btn-block shadow p-2 mb-2"  >Confirm</button>
                                
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer/>
                {(this.state.networkError ? <HandleRes title="You are currently offline." stylecss="alert-danger" /> : '')}
                {(this.state.hasError ? <HandleRes title="sorry there was a problem with your request" stylecss="alert-danger" /> : '')}
 
            </div>
        )
    }
}
export default Signup;